// Veranstaltungstag & Warnung vor kritischen Aenderungen.
//
// Gespeichert wird der Tag auf der Seite "Wertung" (settings/veranstaltung).
// Ab diesem Tag fragt jede kritische Admin-Aktion (Punkteschema, Altersbonus,
// Station/Team bearbeiten oder loeschen, Import, Resets) noch einmal nach.
// Es ist bewusst nur eine WARNUNG, keine Sperre: am Veranstaltungstag muss
// man im Notfall trotzdem korrigieren koennen.
import { fetchWithAuth } from "./fetchWithAuth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Kurz zwischenspeichern, damit nicht jede Aktion einen Request kostet.
const CACHE_MS = 60 * 1000;
let cache = { datum: undefined, geholtAm: 0 };

/** Heutiges Datum als "YYYY-MM-DD" in der lokalen Zeitzone des Geraets. */
export function heuteIso() {
  const d = new Date();
  const zwei = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${zwei(d.getMonth() + 1)}-${zwei(d.getDate())}`;
}

/** "2026-09-28" -> "28.09.2026" */
export function datumDeutsch(iso) {
  if (!iso) return "";
  const [j, m, t] = iso.split("-");
  return `${t}.${m}.${j}`;
}

/** Ist der Tag erreicht (heute oder schon vorbei)? ISO-Strings sind direkt vergleichbar. */
export function istErreicht(iso) {
  return !!iso && heuteIso() >= iso;
}

/** Nach dem Speichern auf der Wertungs-Seite aufrufen, damit sofort der neue Tag gilt. */
export function setzeVeranstaltungstagCache(datum) {
  cache = { datum: datum || null, geholtAm: Date.now() };
}

async function ladeVeranstaltungstag() {
  if (cache.datum !== undefined && Date.now() - cache.geholtAm < CACHE_MS) return cache.datum;
  const data = await fetchWithAuth(`${BACKEND_URL}/wertung`);
  setzeVeranstaltungstagCache(data?.veranstaltungstag);
  return cache.datum;
}

/**
 * Vor einer kritischen Aenderung aufrufen. Liefert `true`, wenn fortgefahren
 * werden darf: entweder ist der Veranstaltungstag noch nicht erreicht (bzw.
 * nicht gesetzt), oder der Admin hat die Warnung bestaetigt.
 *
 * Kann der Tag nicht geladen werden, wird NICHT blockiert – die Warnung ist
 * eine Hilfe und darf eine Korrektur im Notfall nicht verhindern.
 */
export async function kritischeAenderungBestaetigen(beschreibung) {
  let datum = null;
  try {
    datum = await ladeVeranstaltungstag();
  } catch (err) {
    console.warn("[Veranstaltungstag] konnte nicht geladen werden:", err);
    return true;
  }
  if (!istErreicht(datum)) return true;

  const wann = datum === heuteIso()
    ? `Heute (${datumDeutsch(datum)}) ist Veranstaltungstag.`
    : `Der Veranstaltungstag (${datumDeutsch(datum)}) ist bereits vorbei.`;
  return window.confirm(
    `⚠️ ${wann}\n\n` +
      `${beschreibung}\n\n` +
      "Das wirkt sich auf laufende oder bereits ermittelte Ergebnisse aus. Trotzdem fortfahren?"
  );
}
